export enum AnnouncementMessages {
  menuTitle = "announcement.menu.title",
  bellTooltip = "announcement.bell.tooltip",
  dropdownTitle = "announcement.dropdown.title",
  markAllRead = "announcement.dropdown.markAllRead",
  viewAll = "announcement.dropdown.viewAll",
  emptyTitle = "announcement.dropdown.emptyTitle",
  emptySubtitle = "announcement.dropdown.emptySubtitle",
  defaultCta = "announcement.cta.default",
  bannerHighlight = "announcement.banner.highlight",
  bannerDismiss = "announcement.banner.dismiss",
  pageTitle = "announcement.page.title",
  pageSubtitle = "announcement.page.subtitle",
  newButton = "announcement.page.newButton",
  manageAccess = "announcement.page.manageAccess",
  searchPlaceholder = "announcement.page.searchPlaceholder",
  loadError = "announcement.page.loadError",
  retry = "announcement.page.retry",
  listEmpty = "announcement.page.listEmpty",
  listTruncated = "announcement.page.listTruncated",
  tableTitle = "announcement.table.title",
  tablePeriod = "announcement.table.period",
  tableStatus = "announcement.table.status",
  tableReads = "announcement.table.reads",
  tableClicks = "announcement.table.clicks",
  tableActions = "announcement.table.actions",
  statusActive = "announcement.status.active",
  statusScheduled = "announcement.status.scheduled",
  statusExpired = "announcement.status.expired",
  byAuthor = "announcement.list.byAuthor",
  reachEveryone = "announcement.list.reachEveryone",
  reachTenantOne = "announcement.list.reachTenantOne",
  reachTenantMany = "announcement.list.reachTenantMany",
  reachUserOne = "announcement.list.reachUserOne",
  reachUserMany = "announcement.list.reachUserMany",
  clicksHint = "announcement.list.clicksHint",
  formTitleNew = "announcement.form.titleNew",
  formTitleEdit = "announcement.form.titleEdit",
  formSubtitle = "announcement.form.subtitle",
  fieldTitle = "announcement.form.fieldTitle",
  fieldMessage = "announcement.form.fieldMessage",
  fieldLink = "announcement.form.fieldLink",
  fieldLinkLabel = "announcement.form.fieldLinkLabel",
  fieldStartDate = "announcement.form.fieldStartDate",
  fieldEndDate = "announcement.form.fieldEndDate",
  fieldHighlight = "announcement.form.fieldHighlight",
  fieldAudience = "announcement.form.fieldAudience",
  audienceEveryone = "announcement.form.audienceEveryone",
  audienceEveryoneHint = "announcement.form.audienceEveryoneHint",
  audienceTargeted = "announcement.form.audienceTargeted",
  audienceTargetedHint = "announcement.form.audienceTargetedHint",
  audienceSummaryLabel = "announcement.form.audienceSummaryLabel",
  audienceSummaryEmpty = "announcement.form.audienceSummaryEmpty",
  targetTenantsHint = "announcement.form.targetTenantsHint",
  fieldTargetTenants = "announcement.form.fieldTargetTenants",
  fieldTargetUsers = "announcement.form.fieldTargetUsers",
  targetUsersHint = "announcement.form.targetUsersHint",
  audienceRequired = "announcement.form.audienceRequired",
  recipientSearching = "announcement.form.recipientSearching",
  recipientNoResults = "announcement.form.recipientNoResults",
  linkHelper = "announcement.form.linkHelper",
  endAfterStart = "announcement.form.endAfterStart",
  confirmDeleteTitle = "announcement.delete.confirmTitle",
  confirmDeleteMessage = "announcement.delete.confirmMessage",
  interactionsTitle = "announcement.interactions.title",
  interactionsEmpty = "announcement.interactions.empty",
  interactionsUser = "announcement.interactions.user",
  interactionsTenant = "announcement.interactions.tenant",
  interactionsReadAt = "announcement.interactions.readAt",
  interactionsClickedAt = "announcement.interactions.clickedAt",
  interactionsEmail = "announcement.interactions.email",
  interactionsCount = "announcement.interactions.count",
  interactionsExport = "announcement.interactions.export",
  interactionsExporting = "announcement.interactions.exporting",
  interactionsExportPartial = "announcement.interactions.exportPartial",
  managersTitle = "announcement.managers.title",
  managersSubtitle = "announcement.managers.subtitle",
  managersEmpty = "announcement.managers.empty",
  managersGrantLabel = "announcement.managers.grantLabel",
  managersGrantButton = "announcement.managers.grantButton",
  managersRevoke = "announcement.managers.revoke",
  managersGrantedBy = "announcement.managers.grantedBy"
}

export type TranslationAnnouncementMessages = {
  [key in AnnouncementMessages]: string;
};
